import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/services/data-service/data.service';
import { StoreService } from '../shared/services/store-service/store.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: [],
})
export class ServiceComponent implements OnInit {
  loading: boolean;

  constructor(
    private dataService: DataService,
    public storeService: StoreService,
  ) {
    this.loading = true;
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.dataService.initServices();
    } finally {
      this.loading = false;
    }
  }
}
